import React, { useState } from 'react';
import { X } from '@phosphor-icons/react';
import { AnalyzerWeeklyPrompt } from '@Models/types';

interface DeletePromptModalProps {
  isOpen: boolean;
  onClose: () => void;
  prompt: AnalyzerWeeklyPrompt | null;
  onDeletePrompt: (promptTitle: string, authorEmail: string) => Promise<void>;
}

export const DeletePromptModal: React.FC<DeletePromptModalProps> = ({
  isOpen,
  onClose,
  prompt,
  onDeletePrompt,
}) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    if (!prompt) return;

    setLoading(true);
    try {
      await onDeletePrompt(prompt.promptTitle, prompt.authorEmail);
      onClose();
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen || !prompt) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl">
        <div className="mb-4 flex items-center justify-between">
          <h2 className="text-lg font-semibold text-gray-900">Delete Prompt</h2>
          <button
            onClick={onClose}
            className="rounded-md p-2 text-gray-400 hover:bg-gray-100 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>

        <p className="mb-4 text-sm text-gray-700">
          Are you sure you want to delete "{prompt.promptTitle}"? This action
          cannot be undone.
        </p>

        <div className="flex justify-end gap-3">
          <button
            onClick={onClose}
            className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            onClick={handleDelete}
            disabled={loading}
            className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-50"
          >
            {loading ? 'Deleting...' : 'Delete'}
          </button>
        </div>
      </div>
    </div>
  );
};
